import omit from "lodash/omit";
import type { RigFracFocusBin } from "types/charts/requests";
import type { RigFracFocusBinsSelection } from "utils/color/focusColorSync";

type RigFracBinFields = {
  focusBins?: RigFracFocusBin[];
  foldOthers?: boolean;
  maxBins?: Nullable<number>;
};

/**
 * A copy of the request with its bin fields set from the current focus bins and
 * the chart's own Max Bins, never carried over from an earlier request. With
 * the chart's own bins on (`maxBins` a number, or null for no cap), the focus
 * bins still merge spellings and name the bars, but the focus Others no longer
 * folds anything.
 */
export function withRigFracBins<T extends RigFracBinFields>(
  request: T,
  focus: Maybe<RigFracFocusBinsSelection>,
  maxBins: Nullable<number> | undefined
): T {
  const next = omit(request, ["focusBins", "foldOthers", "maxBins"]) as T;
  if (focus) next.focusBins = focus.focusBins;
  if (maxBins === undefined && focus?.foldOthers) next.foldOthers = true;
  // Kept as null, not dropped: the response echo replaces the chart's request,
  // and a missing maxBins would switch Chart Bins back to following the focus.
  if (maxBins === null) next.maxBins = null;
  // Rounded, so a decimal saved before the input was whole-numbers-only can't 400.
  else if (maxBins !== undefined) next.maxBins = Math.max(1, Math.round(maxBins));
  return next;
}
